module.exports = __webpack_public_path__ + "static/media/chia-work-4.4b114e62.jpg";